export default __webpack_public_path__ + "static/media/featuredMb.6c7a2034.png";